import styles from "../list.module.css";
import { ArrowLeft, CheckCircle, Truck } from "react-feather";
import DriverCard from "./DriverCard";

const Step3 = ({ routes, setCurrentStep, setLoading, setSnackbarType, setSnackbarOpen, setSnackbarMessage, setRoutes }) => {
    const routeCount = routes?.length ?? 0;
    const initialCount = Math.max(routeCount, 1);
    const confirmedCount = Math.max(initialCount - routeCount, 0);
    const progressPct = routeCount === 0 ? 100 : Math.round((confirmedCount / initialCount) * 100);

    return (<div className={styles.MainDiv}>
        <div className={styles.Step3TopBar}>
            <button className={styles.Step3BackBU} onClick={(e) => setCurrentStep(2)} aria-label="Back to review routes">
                <ArrowLeft size={18} />
            </button>
            <div className={styles.Step3HeadingWrap}>
                <p className={styles.Step3Title}>Confirm routes</p>
                <p className={styles.Step3Subtitle}>
                    {routeCount > 0
                        ? `${routeCount} driver${routeCount > 1 ? "s" : ""} awaiting confirmation`
                        : "All routes confirmed"}
                </p>
            </div>
        </div>

        {initialCount > 1 && (<div className={styles.Step3Progress} role="progressbar" aria-valuenow={progressPct} aria-valuemin={0} aria-valuemax={100}>
            <div className={styles.Step3ProgressBar} style={{ width: `${progressPct}%` }} />
        </div>)}

        {routeCount === 0 && (<div className={styles.Step3Empty}>
            <CheckCircle size={40} />
            <p className={styles.Step3EmptyTitle}>All drivers confirmed</p>
            <p className={styles.Step3EmptyText}>There are no routes left to review.</p>
        </div>)}

        {routes?.map((item, idx) => {
            return (<div className={styles.DriverSection} key={item?.driver?.id ?? idx}>
                <div className={styles.DriverSectionHead}>
                    <span className={styles.DriverIndexBadge}><Truck size={13} /> <span className={styles.Mono}>{idx + 1} / {routeCount}</span></span>
                </div>
                <DriverCard
                    item={item}
                    routes={routes}
                    setLoading={setLoading.bind(this)}
                    setSnackbarType={setSnackbarType.bind(this)}
                    setSnackbarOpen={setSnackbarOpen.bind(this)}
                    setSnackbarMessage={setSnackbarMessage.bind(this)}
                    setRoutes={setRoutes.bind(this)}
                />
            </div>);
        })}
    </div>);
};

export default Step3;